<template>
    <EmptyState
        description="Once created, all files will be listed here."
        title="No files created yet"
    >
        <template #image>
            <EmptyInbox />
        </template>
        <template #action>
            <DsButton
                size="sm"
                variant="primary"
                @click="$emit('createFile')"
            >
                Create a file
            </DsButton>
        </template>
    </EmptyState>
</template>

<script setup lang="ts">
import EmptyInbox from '@/assets/svg/empty-inbox.svg?component';
import EmptyState from '@/components/shared/EmptyState.vue';
import DsButton from '@ds/button/DsButton.vue';

defineEmits<{
    (event: 'createFile'): void;
}>();
</script>
